import {
  AppointmentTypeControllerApi,
  AppointmentTypeList,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Params {
  appointmentTypeList: AppointmentTypeList;
  xTENANTID?: string;
}

/**
 *
 * @author [Atish Bagate]
 */
export const useAppointmentTypeCreate = () =>
  useMutationWithLoading(async (params: Params) =>
    new AppointmentTypeControllerApi(getConfigObject()).createAppointmentType(
      params?.appointmentTypeList,
      params?.xTENANTID
    )
  );
